var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "format__step" },
    [
      _vm.sourceType === "performance_report"
        ? _c("mds-empty-state", {
            staticClass: "format-empty-state",
            attrs: {
              title: _vm.translate("scheduler.modal.format.emptystate.title"),
              message: _vm.translate(
                "scheduler.modal.format.emptystate.message"
              ),
            },
          })
        : _vm._l(_vm.formatStepInfo, function (parameter, index) {
            return _c(
              "simple-options-combo",
              _vm._g(
                {
                  key: index,
                  attrs: { parameter: parameter, editedFeed: _vm.editedFeed },
                },
                _vm.$listeners
              )
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }